// Los tokens se guardan en UTC; se MUESTRAN siempre en esta zona (configurable, default
// Bogotá), para que "qué día pasó cada cosa" no dependa de dónde está quien mira la
// pantalla (la operación es México + Colombia + EE.UU.). El offset se muestra siempre
// que hay hora, para que nadie tenga que adivinar de qué zona se trata.
const TIMEZONE_OPERACION = process.env.REACT_APP_TIMEZONE_OPERACION || "America/Bogota";

const FMT_FECHA = new Intl.DateTimeFormat("es-CO", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  timeZone: TIMEZONE_OPERACION,
});
const FMT_HORA = new Intl.DateTimeFormat("es-CO", {
  hour: "2-digit",
  minute: "2-digit",
  timeZone: TIMEZONE_OPERACION,
});
const FMT_OFFSET = new Intl.DateTimeFormat("en-US", {
  timeZone: TIMEZONE_OPERACION,
  timeZoneName: "shortOffset",
});

const zonaEtiqueta = () => {
  try {
    const parte = FMT_OFFSET.formatToParts(new Date()).find((p) => p.type === "timeZoneName");
    if (!parte) return "";
    // Guión no separable: en columnas angostas (timeline) el navegador puede partir la
    // línea justo en el guión de "UTC-5", dejando el "5" solo en la línea siguiente.
    return parte.value.replace("GMT", "UTC").replace(/-/g, "\u2011");
  } catch {
    return "";
  }
};

export const formatFecha = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return FMT_FECHA.format(d);
};

export const formatFechaHora = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return `${FMT_FECHA.format(d)} · ${FMT_HORA.format(d)} (${zonaEtiqueta()})`;
};

// ---------- Conversión para inputs datetime-local (formularios de eventos/fotos) ----------
// Los campos "fecha del evento" / "foto tomada en" son datetime-local: el navegador los
// trata siempre como hora local del dispositivo. Como el resto de la app fija todo a
// TIMEZONE_OPERACION, estas dos funciones hacen esa misma conversión a mano para que
// escribir una fecha en el panel coincida con lo que se ve en el rastreo público, sin
// importar en qué zona horaria está la persona que está usando el panel.

const _offsetMinutos = (fecha, timeZone) => {
  const partes = new Intl.DateTimeFormat("en-US", {
    timeZone, hour12: false,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  })
    .formatToParts(fecha)
    .reduce((acc, p) => ({ ...acc, [p.type]: p.value }), {});
  const hora = partes.hour === "24" ? 0 : Number(partes.hour);
  const comoUtc = Date.UTC(+partes.year, +partes.month - 1, +partes.day, hora, +partes.minute, +partes.second);
  return (comoUtc - fecha.getTime()) / 60000;
};

// UTC ISO -> "YYYY-MM-DDTHH:mm" mostrando la hora en TIMEZONE_OPERACION.
export const isoAInputOperacion = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const partes = new Intl.DateTimeFormat("en-US", {
    timeZone: TIMEZONE_OPERACION, hour12: false,
    year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit",
  })
    .formatToParts(d)
    .reduce((acc, p) => ({ ...acc, [p.type]: p.value }), {});
  const hora = partes.hour === "24" ? "00" : partes.hour;
  return `${partes.year}-${partes.month}-${partes.day}T${hora}:${partes.minute}`;
};

// "YYYY-MM-DDTHH:mm" (tal cual se escribió, como hora de TIMEZONE_OPERACION) -> ISO en UTC.
export const inputOperacionAIso = (valor) => {
  if (!valor) return null;
  const comoUtc = new Date(`${valor}:00Z`);
  const offset = _offsetMinutos(comoUtc, TIMEZONE_OPERACION);
  return new Date(comoUtc.getTime() - offset * 60000).toISOString();
};

// Los tipos de unidad son datos (colección tipos_unidad, ABM en /admin/tipos), no un
// binario camión/maquinaria hardcodeado. `tipos` es la lista de /api/tipos.
export const nombreTipo = (tipos, tipoId) =>
  tipos?.find((t) => t.id === tipoId)?.nombre || tipoId || "—";

export const iconoTipo = (tipos, tipoId) =>
  tipos?.find((t) => t.id === tipoId)?.icono;
